import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, apiError } from "@/lib/api";
import { formatBalance } from "@/lib/format";

export default function CariAdjustDialog({ customer, onClose, onDone }) {
  const [direction, setDirection] = useState("borc");
  const [amount, setAmount] = useState("");
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [description, setDescription] = useState("");
  const [busy, setBusy] = useState(false);
  const [idemKey] = useState(() => crypto.randomUUID());

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post(`/customers/${customer.id}/adjustments`, { direction, amount: Number(amount), date, description }, { headers: { "Idempotency-Key": idemKey } });
      toast.success("Cari düzeltme kaydedildi");
      onDone();
    } catch (err) { toast.error(apiError(err)); }
    setBusy(false);
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="cari-adjust-dialog">
        <DialogHeader><DialogTitle>Cari Düzeltme</DialogTitle></DialogHeader>
        <div className="text-[13px] text-slate-600 -mt-2">{customer.title} · Mevcut bakiye <b className="font-mono">{formatBalance(customer.balance)}</b></div>
        <form onSubmit={submit} className="grid grid-cols-2 gap-3">
          <div className="space-y-1"><Label className="text-xs">Yön</Label>
            <Select value={direction} onValueChange={setDirection}>
              <SelectTrigger data-testid="cari-adjust-direction"><SelectValue /></SelectTrigger>
              <SelectContent><SelectItem value="borc">Borç (cari borçlanır)</SelectItem><SelectItem value="alacak">Alacak (cari alacaklanır)</SelectItem></SelectContent>
            </Select>
          </div>
          <div className="space-y-1"><Label className="text-xs">Tutar (₺)</Label><Input type="number" step="0.01" min="0.01" required value={amount} onChange={(e) => setAmount(e.target.value)} data-testid="cari-adjust-amount" /></div>
          <div className="space-y-1"><Label className="text-xs">Tarih</Label><Input type="date" required value={date} onChange={(e) => setDate(e.target.value)} data-testid="cari-adjust-date" /></div>
          <div className="space-y-1 col-span-2"><Label className="text-xs">Açıklama</Label><Input required minLength={3} value={description} onChange={(e) => setDescription(e.target.value)} data-testid="cari-adjust-description" /></div>
          <DialogFooter className="col-span-2">
            <Button type="button" variant="outline" onClick={onClose} data-testid="cari-adjust-cancel">Vazgeç</Button>
            <Button type="submit" disabled={busy} className="bg-blue-600 hover:bg-blue-700" data-testid="cari-adjust-submit">{busy && <Loader2 className="h-4 w-4 animate-spin mr-1" />}Kaydet</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
